import React ,{useState} from 'react'
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Carousels from './carousel';
import Footer from './footer';
import Navbars from './Navbar';

const EdpmsResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedCbeNo, setSelectedCbeNo] = useState(null);
    
 const {
    exportDetails,
    hawbNo,
    courierName,
    errorMessage,
    status,
    multipleIdpms = false,
    errorList = null,
  } = location.state;

  const mergedData = {
    ...exportDetails,
    hawbNo,
    courierName,
  };
  
    const formatKey = (key) => {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/_/g, ' ') 
      .replace(/\b\w/g, (char) => char.toUpperCase());
    };
  
    const displayFields = [
    { fieldKey: 'csbNo', label: 'CSB No' },
    { fieldKey: 'ad_code', label: 'AD CODE PROVIDED IN CBE' },
    { fieldKey: 'transmission_status', label: 'STATUS' },
  ];
  
  return (
    <div className="container-fixed">
      <Navbars/>
      <Carousels />

     <Container className="mt-4 import-form-carousel">
            <h3 className="text-center mb-4">CSB to EDPMS</h3>
            {status === 'FAILURE' ? (
              <div>
                {errorList && errorList.length > 0 && (
                  <div className="alert alert-warning mt-3">
                    <ul className='idpms-error-list'>
                      {errorList.map((error, index) => (
                        <li key={index}>{error}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ) : multipleIdpms ? (
              <div className="text-center">Multiple IDPMS data not supported in this version.</div>
    
            ) : exportDetails ? (
              <table className="table table-bordered table-striped table-sm">
                <tbody>
    
                  {displayFields.map(({ fieldKey, label }) =>
    
                    mergedData[fieldKey] ? (
                      <tr key={fieldKey}>
                        <td>{label}</td>
                        <td>{mergedData[fieldKey]}</td>
                      </tr>
                    ) : null
                  )}
                </tbody>
              </table>
            ) : (
              <div className="text-center">No data available.</div>
            )}
            <br></br>
            <button type="button"
              className="btn btn-danger submit-btn return-btn"
              onClick={() => navigate('/CsbToEdpms')}
            >
              RETURN
            </button>
          </Container>
      <Footer />
    </div>
  )
}
export default EdpmsResult
